import * as React from 'react';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import FormHelperText from '@mui/material/FormHelperText';
import Checkbox from '@mui/material/Checkbox';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250,
		},
	},
};

interface DropDownMultiselectProps {
	data: any[];
	selectedData: any[];
	handleSelectedData: (data: any[]) => void;
	error?: string;
	size: 'small';
}

const LocationsMultiSelect: React.FC<DropDownMultiselectProps> = ({
	data,
	selectedData,
	handleSelectedData,
	error,
	size,
}) => {
	const getSelectedLocations = (locationName: string[]) => {
		const selectedLocations = data.filter((item) => {
			return locationName.includes(item.name);
		});
		return selectedLocations;
	};

	const handleChange = (event: any) => {
		const {
			target: { value },
		} = event;
		handleSelectedData(getSelectedLocations(value));
	};

	const formatData = () => {
		const formattedData = selectedData.map((item) => {
			return item.name;
		});
		return formattedData;
	};

	return (
		<div>
			<FormControl sx={{ width: 360 }} error={error !== ''}>
				<Select
					size={size}
					labelId="multiple-checkbox-label"
					id="multiple-checkbox"
					multiple
					value={formatData()}
					onChange={handleChange}
					renderValue={(selected) => selected.join(', ')}
					MenuProps={MenuProps}
				>
					{data.map((item, index) => (
						<MenuItem
							key={`${item.name}-${index}`}
							value={item.name}
						>
							<Checkbox
								checked={formatData().indexOf(item.name) > -1}
							/>
							<ListItemText primary={item.name} />
						</MenuItem>
					))}
				</Select>
				<FormHelperText>{error}</FormHelperText>
			</FormControl>
		</div>
	);
};

export default LocationsMultiSelect;
